import React from 'react';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import './CommonGuestLayout.scss';
import {
  EMAIL_BODY,
  EMAIL_FOOTER,
  EMAIL_HEADER,
  FACEBOOK,
  INSTAGRAM,
  LINKEDIN,
  TWITTER,
  YOUTUBE,
} from '../../../constants/EmailServicesConst';
import EmailBodyComponent from '../../../components/email-services/EmailBodyComponent';
import { ASSET_URL } from '../../../env/Configurations';
import { validateUrl } from '../../../utils/formUtils';

const CommonGuestLayout = (props) => {
  const {
    activeSection,
    onSetActiveSection,
    componentsList,
    getImageAligin,
    setActiveSection,
    onComponentDrop,
    onDragEnd,
    onClickComponent,
    isPreview,
    isMobilePreview,
    isDragged,
  } = props;

  const onClickLayoutComponent = (e, type) => {
    if (!isPreview) {
      type === EMAIL_BODY ? setActiveSection(EMAIL_BODY) : onSetActiveSection(e, type);
    }
  };

  const onClickRedirectLink = (link) => {
    if (link && validateUrl(link)) window.open(link, '_blank');
  };

  const setLeft = (alignment) => {
    if (alignment === 'right') return '50px';
    if (alignment === 'center') return '30px';
    if (alignment === 'left') return '-10px';
  };

  return (
    <div className='guest-layout'>
      <div
        className={`card layout-card header-layout col-md-10 mt-2 justify-content-center ${
          !isPreview && activeSection === EMAIL_HEADER ? 'layout-card-selected' : ''
        }`}
        onClick={(e) => onClickLayoutComponent(e, EMAIL_HEADER)}
        style={{
          backgroundColor: componentsList.header?.hexCode || '#82828214',
        }}
      >
        {componentsList?.header?.image ? (
          <img
            src={ASSET_URL + componentsList.header?.image}
            className='header-layout-image'
            style={{
              alignSelf: getImageAligin(componentsList?.header?.alignment),
              width: `${componentsList.header?.width}px` || '200px',
              height: `${componentsList.header?.height}px` || '200px',
              padding: componentsList.header?.padding
                ? `${componentsList.header?.top || 0}px ${componentsList.header?.right || 0}px ${
                    componentsList.header?.bottom || 0
                  }px ${componentsList.header?.left || 0}px`
                : 0,
            }}
            onClick={() => onClickRedirectLink(componentsList?.header?.urlLink)}
            alt='header-image'
          />
        ) : (
          <InsertPhotoIcon
            className='image-icon'
            style={{
              alignSelf: getImageAligin(componentsList?.header?.alignment),
            }}
          />
        )}
      </div>
      <div
        className={`card layout-card body-layout col-md-10 mt-2 form-scroll scroll-styled ${
          !isPreview && activeSection === EMAIL_BODY ? 'layout-card-selected ' : ''
        } ${isDragged && componentsList?.body?.length === 0 ? 'drag-start' : ''}`}
        onClick={() => onClickLayoutComponent(null, EMAIL_BODY)}
        onDrop={(e) => onComponentDrop(e)}
        onDragOver={(e) => e.preventDefault()}
      >
        {componentsList?.body?.length > 0 ? (
          <>
            {isPreview ? (
              <div className='col-md-12 px-1 py-3'>
                <div className='w-100 mb-2'>
                  {componentsList.body.map((component, componentIndex) => (
                    <EmailBodyComponent
                      key={componentIndex}
                      component={component}
                      onClickComponent={(e) => onClickComponent(e, componentIndex)}
                      componentNdx={componentIndex}
                      componentsList={componentsList}
                      onClickRedirectLink={onClickRedirectLink}
                      isPreview={true}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                <Droppable droppableId='droppable'>
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      className='col-md-12 px-1 py-3'
                      ref={provided.innerRef}
                    >
                      {componentsList.body.map((component, componentIndex) => (
                        <Draggable
                          key={componentIndex}
                          draggableId={`${component.id}_${componentIndex}`}
                          index={componentIndex}
                          disabled={true}
                        >
                          {(provided, snapshot) => (
                            <div
                              key={componentIndex}
                              className='d-flex'
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div className='w-100 mb-2'>
                                <EmailBodyComponent
                                  component={component}
                                  onClickComponent={(e) => onClickComponent(e, componentIndex)}
                                  componentNdx={componentIndex}
                                  componentsList={componentsList}
                                  isPreview={isPreview}
                                  onClickRedirectLink={onClickRedirectLink}
                                />
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            )}
            {isDragged && componentsList.body.length > 0 && (
              <div className='drop-here-line'>
                <hr className='add-line' />
                <div className='plus-icon'>Drop Here</div>
              </div>
            )}
          </>
        ) : (
          <div className='body-layout-message'>
            <p className='mb-0'>Body</p>
            <p className='mb-0'>Drag &amp; Drop component here</p>
          </div>
        )}
      </div>
      <div
        className={`card layout-card footer-layout col-md-10 mt-2 ${
          !isPreview && activeSection === EMAIL_FOOTER ? 'layout-card-selected' : ''
        }`}
        style={{
          backgroundColor: componentsList?.footer?.social.hexCode || '#82828214',
        }}
        onClick={(e) => onClickLayoutComponent(e, EMAIL_FOOTER)}
      >
        {isMobilePreview ? (
          <div className='form-scroll scroll-styled'>
            <div className='d-flex justify-content-center'>
              {componentsList?.footer?.image.image ? (
                <img
                  src={ASSET_URL + componentsList?.footer?.image.image}
                  style={{
                    width: '80px',
                    height: '80px',
                    padding: componentsList.footer?.image.padding
                      ? `${componentsList.footer?.image.top || 0}px ${
                          componentsList.footer?.image.right || 0
                        }px ${componentsList.footer?.image.bottom || 0}px ${
                          componentsList.footer?.image.left || 0
                        }px`
                      : 0,
                    position: 'relative',
                  }}
                  className='footer-layout-image'
                  onClick={() => onClickRedirectLink(componentsList?.footer?.image.urlLink)}
                  alt='footer-image'
                />
              ) : (
                <InsertPhotoIcon className='image-icon footer-layout-image' />
              )}
            </div>
            <div>
              <p
                style={{
                  textAlign: componentsList?.footer?.text.alignment || 'center',
                  fontSize: `${componentsList?.footer?.text.fontSize}px` || '10px',
                  height: componentsList?.footer?.text?.text?.length >= 40 ? '50px' : '20px',
                  fontWeight: componentsList?.footer?.text.bold ? 'bold' : 'normal',
                  fontStyle: componentsList?.footer?.text.italic ? 'italic' : 'normal',
                  textDecoration: componentsList?.footer?.text.underline ? 'underline' : 'none',
                  color: componentsList?.footer?.text.textColor || '#828282',
                }}
              >
                {componentsList?.footer?.text?.text || 'Text Input Field 1'}
              </p>
            </div>
            <div>
              <p
                style={{
                  textAlign: componentsList?.footer?.social.alignment || 'center',
                  fontSize: `${componentsList?.footer?.social.fontSize}px` || '10px',
                  fontWeight: componentsList?.footer?.social.bold ? 'bold' : 'normal',
                  fontStyle: componentsList?.footer?.social.italic ? 'italic' : 'normal',
                  textDecoration: componentsList?.footer?.social?.underline ? 'underline' : 'none',
                  color: componentsList?.footer?.social.textColor || '#828282',
                }}
              >
                {componentsList?.footer?.social.text || 'Text Input Field 2'}
              </p>
            </div>
            <div className='d-flex px-3'>
              {componentsList?.footer?.social.linkedIn && (
                <img
                  className='px-1 social-icon'
                  src={LINKEDIN}
                  onClick={() => onClickRedirectLink(componentsList?.footer?.social.linkedIn)}
                  alt='linkedIn'
                />
              )}
              {componentsList?.footer?.social.facebook && (
                <img
                  className='px-1 social-icon'
                  src={FACEBOOK}
                  onClick={() => onClickRedirectLink(componentsList?.footer?.social.facebook)}
                  alt='facebook'
                />
              )}
              {componentsList?.footer?.social.twitter && (
                <img
                  className='px-1 social-icon'
                  src={TWITTER}
                  onClick={() => onClickRedirectLink(componentsList?.footer?.social.twitter)}
                  alt='twitter'
                />
              )}
              {componentsList?.footer?.social.instagram && (
                <img
                  className='px-1 social-icon'
                  src={INSTAGRAM}
                  onClick={() => onClickRedirectLink(componentsList?.footer?.social.instagram)}
                  alt='instagram'
                />
              )}
              {componentsList?.footer?.social.youTube && (
                <img
                  className='px-1 social-icon'
                  src={YOUTUBE}
                  onClick={() => onClickRedirectLink(componentsList?.footer?.social.youTube)}
                  alt='youTube'
                />
              )}
            </div>
          </div>
        ) : (
          <>
            <div className='d-flex justify-content-end form-scroll scroll-styled'>
              <div className='social-text'>
                <p
                  className='footer-layout-text2'
                  style={{
                    textAlign: componentsList?.footer?.social.alignment || 'center',
                    fontSize: `${componentsList?.footer?.social.fontSize}px` || '10px',
                    fontWeight: componentsList?.footer?.social.bold ? 'bold' : 'normal',
                    fontStyle: componentsList?.footer?.social.italic ? 'italic' : 'normal',
                    textDecoration: componentsList?.footer?.social?.underline
                      ? 'underline'
                      : 'none',
                    color: componentsList?.footer?.social.textColor || '#828282',
                    padding: componentsList?.footer?.social.padding
                      ? `${componentsList.footer?.social?.top || 0}px ${
                          componentsList.footer?.social?.right || 0
                        }px ${componentsList.footer?.social?.bottom || 0}px ${
                          componentsList.footer?.social?.left || 0
                        }px`
                      : 0,
                  }}
                >
                  {componentsList?.footer?.social?.text || 'Text Input Field 2'}
                </p>
              </div>
            </div>
            <div className='d-flex justify-content-between align-items-center'>
              <div
                style={{
                  position: componentsList?.footer?.image.image ? 'absolute' : 'relative',
                  top: componentsList?.footer?.image.image ? '0' : '-16px',
                }}
              >
                {componentsList?.footer?.image.image ? (
                  <img
                    src={ASSET_URL + componentsList?.footer?.image.image}
                    className='footer-layout-image'
                    style={{
                      width: `${componentsList.footer?.image.width}px` || '200px',
                      height: `${componentsList.footer?.image.height}px` || '200px',
                      padding: componentsList.footer?.image.padding
                        ? `${componentsList.footer?.image.top || 0}px ${
                            componentsList.footer?.image.right || 0
                          }px ${componentsList.footer?.image?.bottom || 0}px ${
                            componentsList.footer?.image.left || 0
                          }px`
                        : 0,
                      position: 'relative',
                      left: setLeft(componentsList?.footer?.image.alignment),
                    }}
                    onClick={() => onClickRedirectLink(componentsList?.footer?.image.urlLink)}
                    alt='footer-image'
                  />
                ) : (
                  <InsertPhotoIcon className='image-icon footer-layout-image' />
                )}
              </div>
              <div
                style={{
                  marginLeft: componentsList?.footer?.image.image ? '160px' : '0',
                }}
              >
                <p
                  className='footer-layout-text1 form-scroll scroll-styled'
                  style={{
                    textAlign: componentsList?.footer?.text.alignment || 'center',
                    fontSize: `${componentsList?.footer?.text.fontSize}px` || '10px',
                    height: componentsList?.footer?.text?.text?.length >= 40 ? '50px' : '20px',
                    fontWeight: componentsList?.footer?.text.bold ? 'bold' : 'normal',
                    fontStyle: componentsList?.footer?.text.italic ? 'italic' : 'normal',
                    textDecoration: componentsList?.footer?.text?.underline ? 'underline' : 'none',
                    color: componentsList?.footer?.text.textColor || '#828282',
                    padding: componentsList?.footer?.text.padding
                      ? `${componentsList.footer?.text?.top || 0}px ${
                          componentsList.footer?.text?.right || 0
                        }px ${componentsList.footer?.text?.bottom || 0}px ${
                          componentsList.footer?.text?.left || 0
                        }px`
                      : 0,
                  }}
                >
                  {componentsList?.footer?.text.text || 'Text Input Field 1'}
                </p>
              </div>
              <div className='d-flex px-3'>
                {componentsList?.footer?.social.linkedIn && (
                  <img
                    className='px-1'
                    src={LINKEDIN}
                    onClick={() => onClickRedirectLink(componentsList?.footer?.social.linkedIn)}
                    alt='linkedIn'
                  />
                )}
                {componentsList?.footer?.social.facebook && (
                  <img
                    className='px-1'
                    src={FACEBOOK}
                    onClick={() => onClickRedirectLink(componentsList?.footer?.social.facebook)}
                    alt='facebook'
                  />
                )}
                {componentsList?.footer?.social.twitter && (
                  <img
                    className='px-1'
                    src={TWITTER}
                    onClick={() => onClickRedirectLink(componentsList?.footer?.social.twitter)}
                    alt='twitter'
                  />
                )}
                {componentsList?.footer?.social.instagram && (
                  <img
                    className='px-1'
                    src={INSTAGRAM}
                    onClick={() => onClickRedirectLink(componentsList?.footer?.social.instagram)}
                    alt='instagram'
                  />
                )}
                {componentsList?.footer?.social.youTube && (
                  <img
                    className='px-1'
                    src={YOUTUBE}
                    onClick={() => onClickRedirectLink(componentsList?.footer?.social.youTube)}
                    alt='youTube'
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CommonGuestLayout;
